import type { AlertColor } from '@mui/material'
import type { TFunction } from 'i18next'

export interface ControllerConfigurationClipboardData {
  appJsonText?: string
  raspiPropertiesText?: string
  controllerId: string
  controllerEquipmentNumber?: number
}

type PushAlertType = (params: { message: string; severity: AlertColor }) => void

export async function readControllerConfigurationFromClipboard(pushAlert: PushAlertType, t: TFunction) {
  try {
    const clipboardText = await navigator.clipboard.readText()
    if (clipboardText) {
      try {
        const clipboardData: ControllerConfigurationClipboardData = JSON.parse(clipboardText)
        const { appJsonText, raspiPropertiesText } = clipboardData
        if (appJsonText) {
          // force error in case of invalid app.json
          JSON.parse(appJsonText)
        }
        if (appJsonText || raspiPropertiesText) {
          return clipboardData
        }
      } catch {
        /* show the warning about empty config */
      }
    }
    pushAlert({
      message: t('controllers.configuration.tree.controller_actions.paste_config_empty'),
      severity: 'warning',
    })
  } catch {
    pushAlert({
      message: t('controllers.configuration.tree.controller_actions.paste_config_failed'),
      severity: 'error',
    })
  }
  return null
}

export async function writeControllerConfigurationToClipboard(
  clipboardData: ControllerConfigurationClipboardData,
  pushAlert: PushAlertType,
  t: TFunction,
) {
  try {
    await navigator.clipboard.writeText(JSON.stringify(clipboardData))
    pushAlert({
      message: t('controllers.configuration.tree.controller_actions.copy_config_success'),
      severity: 'success',
    })
  } catch {
    pushAlert({
      message: t('controllers.configuration.tree.controller_actions.copy_config_failed'),
      severity: 'error',
    })
  }
}
